export const isValidYouTubeUrl = (url) => {
    return /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/.test(url);
  };
  
  export const isValidInstagramUrl = (url) => {
    return /^(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9_.]+\/?(\?[\w=&]+)?$/i.test(
      url
    );
  };
  
  export const isValidFacebookUrl = (url) => {
    return /^(https?:\/\/)?(www\.)?facebook\.com\/[A-Za-z0-9_.]+(\/)?$/i.test(
      url
    );
  };
  
  export const isValidTiktokUrl = (url) => {
    return /^(https?:\/\/)?www\.tiktok\.com/.test(url);
  };
  
  export const isValidTwitterUrl = (url) => {
    return /^(https?:\/\/)?twitter\.com/.test(url);
  };
  
  export const isValidLinkedInUrl = (url) => {
    return /^http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?/i.test(url);
  };
  
  export const isValidWebsiteUrl = (url) => {
    return /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(
      url
    );
  };

  export const isVideoUrl = (url) => {
    return (
      /\.(mp4|mov|avi|mkv|webm|flv|wmv|m4v|3gp|3g2)$/i.test(url) ||
      /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/(watch\?v=|embed\/|v\/|.+\?v=)?([^&=%\?]{11})/.test(
        url
      )
    );
  };
  